import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';

interface H5SidebarTopicListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
}

@inject('app', 'site', 'user')
@observer
class H5SidebarTopicList extends React.Component<H5SidebarTopicListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        const { site, app, ...props } = this.props;
        return <>
            <div className={styles.topicListBox}>
                
            </div>
        </>
        
    }
}

export default H5SidebarTopicList;